module.exports = __webpack_public_path__ + "assets/img/s2.e5db2b56.png";